export default {
  langs: [],
  lang: 'en_US',
  packageVersion: '',
  translations: {}
};
